module.exports = __webpack_public_path__ + "img/basque-country.435fc28e.png";